export const routes = [
    {
        name: 'index',
        path: ['/', '/index.html'],
        page: 'home'
    },
    {
        name: 'index',
        path: ['/spicy-pina', '/fresa-sandia', '/mango-durazno', '/limon-pepino'],
        page: 'beer'
    },
    {
        name: 'tyc',
        path: ['/lista-de-campanas'],
        page: 'tyc'
    },
    {
        name: 'forms',
        path: ['/registro', '/registro-trivia', '/registro-juego', '/iniciar-sesion', '/gracias-trivia', '/gracias-juego'],
        page: 'validationForms'
    },
    {
        name: 'trivia',
        path: ['/trivia'],
        page: 'trivia'
    },
    {
        name: 'userArea',
        path: ['/zona-de-usuario'],
        page: 'userArea'
    },
    {
        name: 'ranking',
        path: ['/ranking'],
        page: 'ranking'
    },
    {
        name: 'game',
        path: ['/juega-y-gana'],
        page: 'game'
    },
    {
        name: 'recipes',
        path: '/recetas/:path',
        component: 'recipes'
    },
]